import React from 'react';
import { FormLabel } from '@chakra-ui/react';

const CustomLabel = ({ labelText, required = false }) => {
  return (
    <FormLabel>
      {labelText}
      {required && <span style={{ color: 'red' }}> *</span>} {/* Optional asterisk for required fields */}
    </FormLabel>
  );
};

export default CustomLabel;
